export enum TimePeriod {
  'Always' = 'ALWAYS',
  'LastSevenDays' = 'LAST_SEVEN_DAYS',
  'LastThirtyDays' = 'LAST_THIRTY_DAYS',
  'LastNinetyDays' = 'LAST_NINETY_DAYS',
  'LastYear' = 'LAST_YEAR',
  'CustomRange' = 'CUSTOM_RANGE',
}
